const ValidatedTaxInfo = 'epic.affiliate.settings.tax.profile.status.validated';
const TaxInfoOnFile = 'epic.affiliate.settings.tax.profile.status.onfile';
const ValidationDeferred = 'epic.affiliate.settings.tax.profile.status.deffered';
const TaxInfoRequiresUpdate = 'epic.affiliate.settings.tax.profile.status.required_update';
const MissingTaxInfo = 'epic.affiliate.settings.tax.profile.status.mismatch';
const InvalidTaxInfo = 'epic.affiliate.settings.tax.profile.status.invalidated';
const Deactivated = 'epic.affiliate.settings.tax.profile.status.deactivated';
const TaxInfoNotRequired = 'epic.affiliate.settings.tax.profile.status.not_required';
const NameMismatch = 'epic.affiliate.settings.tax.profile.status.name_mis_match.v2';

export default {
    ValidatedTaxInfo,
    TaxInfoOnFile,
    ValidationDeferred,
    TaxInfoRequiresUpdate,
    MissingTaxInfo,
    InvalidTaxInfo,
    Deactivated,
    TaxInfoNotRequired,
    NameMismatch
};
